<template>
    <Page header="Главная" type="" :nopadding="false" header_pos="left">
        <template #body>
            <div v-if="!isAuth" class="flex w-full">
                <AuthForm />
            </div>
            <div v-else class="flex w-full">
                Добро пожаловать! 
            </div>
        </template>
    </Page>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import AuthForm from '@/components/personal/auth_form.vue'
import Page from '@/components/public/page.vue'

export default {
    data() {
        return {
            loading: false,
            list: null,
        }
    },
    components: {
        AuthForm,
        Page
    },
    methods: {

    },
    computed: {
        isAuth: function () { return this.$store.getters.isAuthenticated },
        accessCodes: function () { return this.$store.getters.StateUserAccessCodes },
    },
    async mounted() {
        
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>